import React from "react";
import "./BottomButtons.scss";

export const BottomButtons: React.FC = ({ children }) => (
  <div className="bottom-buttons">{children}</div>
);
